import { isArray } from 'lodash';

/* eslint-disable no-restricted-globals */
const useTotalInvoiceAmount = (invoice = [], receivedInvoiceList = []) => {
	if (isArray(invoice) && isArray(receivedInvoiceList)) {
		const allotednvoiceAmount = invoice?.reduce(
			(accumulation, currentValue) =>
				accumulation + Number(currentValue?.invoice_amount) || 0,
			0
		);

		const receivedInvoiceAmount = receivedInvoiceList?.reduce(
			(accumulation, currentValue) =>
				accumulation + Number(currentValue?.invoice_amount) || 0,
			0
		);

		return allotednvoiceAmount + receivedInvoiceAmount;
	}

	return 0;
};

export default useTotalInvoiceAmount;
